import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
    borderRadius: '0',
    padding: '0px 15px',
    position: 'relative',
    overflow: 'hidden',
    height: 'var(--header-h)',
    zIndex: 2,
    boxShadow: 'var(--shadows-5)',

    '& .viboButton': {
      whiteSpace: 'nowrap',
    },

    '& .container': {
      height: '100%',
    },

    '& .containerContent': {
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',

      '& .viboMenu': {
        width: '100%',
      },
    },
  },

  goBack: {
    padding: '0 12px',
    minWidth: '48px',
    left: '0',
    height: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    position: 'absolute',
  },
}));

export default useStyles;
